import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to interpolate variables in translation strings
export function interpolate(
  template: string,
  variables: Record<string, string | number>
): string {
  return template.replace(/\{(\w+)\}/g, (match, key) => {
    return variables[key]?.toString() || match;
  });
}

// لینک‌های منو/ویجت گاهی به‌صورت دستی و بدون "/" اول ذخیره می‌شن
// (مثلاً "shop/category/products/x" به‌جای "/shop/category/products/x").
// چون next/link یه href بدون "/" رو نسبت به مسیر فعلی صفحه resolve می‌کنه،
// این باعث می‌شه با چند بار کلیک روی لینک‌های مختلف، آدرس‌ها پشت سر هم بچسبن.
export const normalizeLink = (link?: string | null): string => {
  if (!link) return '';
  const trimmed = link.trim();
  if (
    trimmed === '' ||
    trimmed.startsWith('/') ||
    trimmed.startsWith('#') ||
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('tel:')
  ) {
    return trimmed;
  }
  return `/${trimmed}`;
};

export const formatDate = (dateString?: string | null) => {
  // بعضی رکوردها created_at ندارن؛ قبلاً همون مقدار null برگردونده می‌شد و
  // هر جا روی خروجی .replace/.split صدا زده می‌شد، کرش می‌کرد
  if (!dateString || typeof dateString !== 'string') return '';

  try {
    const [datePart, timePart] = dateString.split(' ');
    const [year, month, day] = datePart.split('/').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);

    const pad = (num: number) => String(num).padStart(2, '0');

    // خروجی: 1403/07/27، 09:40
    return `${year}/${pad(month)}/${pad(day)}، ${pad(hour)}:${pad(minute)}`;
  } catch {
    return dateString;
  }
};
